<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de faltosos e aprazamentos">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/relatorio-faltoso-aprazamento/List'

export default {
    components: { List },
}
</script>